import React from "react";
import { Globe2, Cpu, TrendingUp, ShieldCheck } from "lucide-react";
import StarField from "./StarField";

/**
 * AboutCapabilities v2 — premium dark-navy strip directly under the hero.
 *
 *  Replaces the previous pastel-blue icon boxes with a sleek navy band that
 *  carries the brand colour through from the hero. Matches the /buy-leads
 *  FloatCard treatment.
 *
 *  All 4 titles are SAME WORD-COUNT visual weight to eliminate misalignment.
 */
const ITEMS = [
  { Icon: Globe2,       title: "Global infrastructure", body: "Routing financial demand across markets and channels." },
  { Icon: Cpu,          title: "AI powered",            body: "Voice + chat agents qualifying every enquiry in real-time." },
  { Icon: TrendingUp,   title: "Performance driven",    body: "Quality leads, measurable outcomes, transparent margins." },
  { Icon: ShieldCheck,  title: "Built to connect",      body: "Compliance-native — consent, suppression and audit by default." },
];

export default function AboutCapabilities() {
  return (
    <section className="relative bg-[#0F172A] text-white overflow-hidden" data-testid="about-capabilities">
      <StarField opacity={0.4} />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14 lg:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {ITEMS.map((it, i) => (
            <div
              key={i}
              className="group relative rounded-2xl border border-white/[0.08] bg-white/[0.02] p-6 hover:bg-white/[0.04] hover:border-[#3d7bff]/40 transition-all"
              data-testid={`capability-${i}`}
            >
              <span className="inline-grid place-items-center size-10 rounded-lg bg-[#3d7bff]/[0.12] text-[#7da9ff] mb-5 ring-1 ring-[#3d7bff]/25">
                <it.Icon className="size-5" strokeWidth={1.7} />
              </span>
              <div className="text-[15px] font-semibold tracking-tight text-white">{it.title}</div>
              <p className="mt-1.5 text-[13px] leading-relaxed text-white/55">{it.body}</p>
              {/* subtle accent corner */}
              <span className="absolute top-5 right-5 size-1 rounded-full bg-[#3d7bff]/60 opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
